import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RouteAnnouncer } from "./components/RouteAnnouncer";
import { ScrollToTop } from "./components/ScrollToTop";
import { HomePage } from "./pages/HomePage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";
// import { AccessibilityStatementPage } from "./pages/AccessibilityStatementPage";
import { BlogListPage } from "./pages/BlogListPage";
import { BlogPostPage } from "./pages/BlogPostPage";
import { NotFoundPage } from "./pages/NotFoundPage";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteAnnouncer />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="polityka-prywatnosci" element={<PrivacyPolicyPage />} />
          <Route path="regulamin" element={<TermsOfServicePage />} />
          {/* Route tymczasowo wyłączony — deklaracja dostępności dla podmiotów prywatnych do weryfikacji */}
          {/* <Route path="deklaracja-dostepnosci" element={<AccessibilityStatementPage />} /> */}
          <Route path="blog" element={<BlogListPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
